import React from 'react'

export default function TitleSection() {
    return (
        <div className='contact-title-section d-flex align-items-center justify-content-center'>
            <h3 style={{ fontWeight: '800', fontSize: '2em' }}>Sustainability</h3>
        </div>
    )
}
